/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { format, subDays, subHours } from 'date-fns';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Icon,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Typography
} from '@material-ui/core';
import ChatAltIcon from '../../icons/ChatAlt';
import CreditCardIcon from '../../icons/CreditCard';
import ShoppingCartIcon from '../../icons/ShoppingCart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import useAuth from '../../hooks/useAuth';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import { difference } from 'lodash';
import { alpha } from '@mui/material/styles';
import { toneAlpha, grey, getTone } from '../../theme/tones';

// const now = new Date();

const iconsMap = {
  item_shipped: ShoppingCartIcon,
  new_message: ChatAltIcon,
  order_placed: CreditCardIcon
};

const NotificationsPopover = () => {
  const anchorRef = useRef(null);
  const audioRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [notificationNumber, setNotificationNumber] = useState(0);
  const [isSoundEnabled, setIsSoundEnabled] = useState(true);
  const [lastNotificationCount, setLastNotificationCount] = useState(0);
  const [isNewNotification, setIsNewNotification] = useState(false);

  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();

 useEffect(() => {
  
  if (!audioRef.current) {
    audioRef.current = new Audio('/static/notification.mp3'); // Assure-toi du bon chemin
  }

  if (notificationNumber > lastNotificationCount && isNewNotification && !open && isSoundEnabled) {
    
    audioRef.current.currentTime = 0; // Remettre le son au début
    audioRef.current.play().then(() => {
      setLastNotificationCount(notificationNumber);
    }).catch((error) => {
      console.error("❌ Erreur lors de la lecture du son :", error);
    });
  }
}, [notificationNumber, lastNotificationCount, isSoundEnabled]);

  useEffect(() => {
    const socket = new WebSocket(`wss://syndays.fr/ws/?X-UserId=${user.id}&tenant=${tenant}`); // l'adresse du serveur WebSocket

    // Gestionnaire d'événements pour la connexion réussie
    socket.onopen = () => {
      const message = {
        handler: 'RecallsHandler',
        message: 'GetNotificationsUpdate'
      };
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      }
    };

    socket.onmessage = (event) => {
      const message = {
        handler: 'RecallsHandler',
        message: 'GetNotificationsUpdate'
      };
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      }
      try {
        const data = JSON.parse(event.data);
        // Traitement des données
        if (data.type === 'recall_notification') {
          const notificationsData = data.data.notifications;
          const notificationsNum = data.data.table_length;
          if (notificationsData.length > 0) {
            const updatedNotifications = notifications.map((existing) => {
              const notificationExists = notificationsData.find((recall) => recall.id === existing.id);
              if (notificationExists) {
                // La notification existe déjà, mettez à jour les champs nécessaires
                return {
                  ...existing,
                  date: notificationExists.date,
                  titre: 'Nouveau rappel à venir',
                  customer: notificationExists.customer,
                };
              }
              return null;// Retourne null pour les notifications à supprimer
            }).filter(Boolean);

            // Ajouter les nouvelles notifications qui n'existent pas encore
            notificationsData.forEach((recall) => {
              const existingNotification = updatedNotifications.find((existing) => existing.id === recall.id);

              if (!existingNotification) {
                setIsNewNotification(true);
                updatedNotifications.push({
                  id: recall.id,
                  date: recall.date,
                  titre: 'Nouveau rappel à venir',
                  customer: recall.customer,
                });
              }
            });
            // Actualiser la liste des notifications
            setNotifications(updatedNotifications);
            setNotificationNumber(notificationsNum);
            setLastNotificationCount(notificationsNum);
          } else {
            setNotifications([]);
          }
        }
        // } else if (data.type === 'commercial_add_notification') {
        //   const commercialNotificationsData = data.data;

        //   if (commercialNotificationsData.length > 0) {
        //     const userIsTargeted = commercialNotificationsData.some((notification) => notification.userId === user.id);
        //     if (userIsTargeted) {
        //       setNotifications((prevNotifications) => [
        //         ...prevNotifications,
        //         {
        //           id: 1,
        //           date: new Date(),
        //           titre: 'Vous avez été ajouté à une nouvelle campagne',
        //         },
        //       ]);
        //       // Mettez à jour le nombre total de notifications
        //       setNotificationNumber(notificationNumber + 1);
        //       setLastNotificationCount(notificationNumber + 1);
        //     }
        //   }
        // }
      } catch (error) {
        console.error('Erreur lors de l\'analyse du message WebSocket :', error);
      }
    };

    socket.onclose = (event) => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send('ping close');
      }
    };

    socket.onerror = (event) => {
      console.error('Erreur WebSocket :', event);
    };

      // 🧹 Cleanup : fermer la connexion WebSocket à la fin
  return () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
  };
  }, [user.id, tenant]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleNotificationClick = (notification) => {
    // Mettre à jour le statut "vu" de la notification
    setNotifications((prevNotifications) => {
      const updatedNotifications = prevNotifications.map((n) => (n.id === notification.id ? { ...n, vu: true } : n));
      return updatedNotifications;
    });
    setLastNotificationCount(notifications.length - 1);
    const socket = new WebSocket(`wss://syndays.fr/ws/?X-UserId=${user.id}&tenant=${tenant}`);
    socket.onopen = () => {
      const message = {
        handler: 'RecallsHandler',
        message: 'MarkNotificationAsRead',
        data: {
          notificationId: notification.id
        }
      };
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      }
    };
  };

  const handleNotificationsOpenClick = (selectedNotifications) => () => {
    setOpen(true);
    setNotifications((prevNotifications) => {
      const updatedNotifications = prevNotifications.map((n) => {
        if (selectedNotifications.some((selectedNotification) => selectedNotification.id === n.id)) {
          return { ...n, is_not_countable: true };
        }
        return n;
      });
      return updatedNotifications;
    });

    setLastNotificationCount((prevNotifications) => prevNotifications.length - selectedNotifications.length);

    const socket = new WebSocket(`wss://syndays.fr/ws/?X-UserId=${user.id}&tenant=${tenant}`);
    socket.onopen = () => {
      selectedNotifications.forEach((notification) => {
        const message = {
          handler: 'RecallsHandler',
          message: 'MarkNotificationsAsReadAndNotcountable',
          data: {
            notificationId: notification.id
          }
        };
        if (socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify(message));
        }
      });
    };
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleNotificationsOpenClick(notifications)}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          position: 'relative',
          p: 1.2,
          borderRadius: '12px',
          bgcolor: open ? toneAlpha('indigo', 0.08) : 'transparent',
          color: open ? 'primary.main' : 'text.secondary',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            bgcolor: 'action.hover',
            color: 'text.primary'
          }
        }}
      >
        <NotificationsIcon sx={{ fontSize: 21 }} />
        {!open && notificationNumber > 0 && ( // Ajoutez cette condition
          <Box
            sx={{
              position: 'absolute',
              top: 3,
              right: 2,
              minWidth: 17,
              height: 17,
              px: 0.4,
              background: `linear-gradient(135deg, ${getTone('rose').base} 0%, ${getTone('rose').color} 100%)`,
              borderRadius: '999px',
              border: '2px solid',
              borderColor: 'background.paper',
              boxShadow: (theme) => `0 4px 10px -4px ${alpha(theme.palette.error.main, 0.9)}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: grey(0),
              fontSize: '0.62rem',
              fontWeight: 800,
              lineHeight: 1
            }}
          >
            {notificationNumber > 99 ? '99+' : notificationNumber}
          </Box>
        )}
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom'
        }}
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: '20%' }
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography
            color="textPrimary"
            variant="h6"
          >
            Notifications
          </Typography>
        </Box>
        {notifications.length === 0
          ? (
            <Box sx={{ p: 2 }}>
              <Typography
                color="textPrimary"
                variant="subtitle2"
              >
                Il n&apos;y a pas de notifications
              </Typography>
            </Box>
          )
          : (
            <>
              <List disablePadding>
                {notifications.map((notification) => (
                  <ListItem
                    divider
                    key={notification.id}
                    sx={{
                      backgroundColor: 'action.hover',
                      '&:hover': {
                        backgroundColor: 'background.paper', // Couleur de fond au survol
                      },
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        sx={{
                          backgroundColor: 'primary.main',
                          color: 'primary.contrastText'
                        }}
                      >
                        <PhoneCallbackIcon fontSize="small" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={(
                        <Link
                          color="textPrimary"
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleNotificationClick(notification)}
                          underline="none"
                          variant="subtitle2"
                        >
                          {notification.titre || ''}
                        </Link>
                      )}
                      secondary={(
                        <div>
                          <div>
                            {notification.date && (
                              `Le ${format(new Date(notification.date), "dd/MM/yyyy 'à' HH:mm")}`
                            )}
                          </div>
                          <div>
                            {'avec '}
                            <Link
                              component="a"
                              href={`/dashboard/customers/${notification.customer.id}`}
                              color="inherit"
                              underline="none"
                            >
                              <strong>{notification.customer.name || ''}</strong>
                            </Link>
                          </div>
                        </div>
                      )}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
      </Popover>
    </>
  );
};

export default NotificationsPopover;
